<template>
  <div id="contact" class="section section-contact container">
    <h1>CONTACT</h1>
    <img src="./../assets/mustata-only.png" alt class="logo-mustata" />
    <b-container>
      <b-row class="justify-content-end" style="border: 2px solid black;">
        <b-col cols="12" md="6" lg="6" class="cover" style="min-height:350px;"></b-col>

        <b-col cols="12" md="6" lg="6" class="text-left">
          <b-form @submit="onSubmit" style="padding: 15px;">
            <b-form-group id="input-group-2" label="Nume:" label-for="input-2">
              <b-form-input id="input-2" v-model="form.name" required placeholder="Numele tău"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-1" label="Adresă e-mail:" label-for="input-1">
              <b-form-input
                id="input-1"
                v-model="form.email"
                type="email"
                required
                placeholder="Adresa ta de e-mail"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-3" label="Mesaj:" label-for="input-3">
              <b-form-textarea
                id="textarea"
                v-model="form.message"
                placeholder="Mesajul tău"
                rows="3"
                max-rows="3"
                required
              ></b-form-textarea>
            </b-form-group>

            <b-button
              squared
              type="submit"
              class="btn-brown btn-warning"
              :disabled="submitted"
            >Trimite</b-button>

            <div v-if="savingSuccessful" role="alert" class="styled-alert">
              <b-alert
                :show="dismissCountDown"
                dismissible
                @dismissed="dismissCountDown = 0"
                @dismiss-count-down="countDownChanged"
              >Mesaj trimis!</b-alert>
            </div>

            <div class="contact-details text-right mt-5">
              <div class="d-flex align-items-center justify-content-end mb-2">
                <span>Strada Zizinului, Nr. 109 Bis, 500407, Brașov</span>
                <b-icon icon="house-fill"></b-icon>
              </div>

              <div class="d-flex align-items-center justify-content-end mb-2">
                <span>beremustata@gmail.com</span>
                <b-icon icon="envelope-fill"></b-icon>
              </div>

              <div class="d-flex align-items-center justify-content-end mb-2">
                <span>0799976596</span>
                <b-icon icon="chat-square-dots-fill"></b-icon>
              </div>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: "",
        name: "",
        message: ""
      },
      submitted: false,
      savingSuccessful: false,
      dismissSecs: 50,
      dismissCountDown: 0
    };
  },

  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },

    resetForm() {
      this.form.email = "";
      this.form.name = "";
      this.form.message = "";
    },

    onSubmit(evt) {
      evt.preventDefault();
      let vm = this;
      this.axios
        .post("https://submit-form.com/gVXhWeIL1gPFyElCEWmO3", {
          email: this.form.email,
          name: this.form.name,
          message: this.form.message
        })
        .then(function(response) {
          console.log(response);
          vm.savingSuccessful = true;
          vm.submitted = true;
          vm.showAlert();
          vm.resetForm();
        })
        .catch(function(error) {
          vm.output = error;
        });
    }
  }
};
</script>

<style>
.cover {
  background-image: url("./../assets/mail.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.contact-details svg {
  min-width: 25px;
  min-height: 25px;
  fill: #8b4e2e;
  margin-left: 15px;
}

.contact-details span {
  font-size: 12px;
}

.section-contact p,
span {
  font-size: 14px;
}

.alert-info {
  color: #8b4e2e;
  background-color: transparent;
  border-color: #8b4e2e;
  font-size: 12px;
}

.styled-alert {
  margin-top: 10px;
}

label#input-group-2__BV_label_.d-block,
label#input-group-1__BV_label_.d-block,
label#input-group-3__BV_label_.d-block {
  font-size: 14px;
}

input#input-2.form-control,
input#input-1.form-control,
textarea#textarea.form-control {
  font-size: 12px;
  border-radius: 0;
}

.btn.btn-brown {
  font-size: 12px;
}

.alert-info {
  color: black;
  background-color: transparent;
  border-color: #8b4e2e;
  font-size: 14px;
}

/* @media (max-width: 575.98px) {
  .section-contact p,
  span {
    font-size: 12px;
  }

  label#input-group-2__BV_label_.d-block,
  label#input-group-1__BV_label_.d-block,
  label#input-group-3__BV_label_.d-block {
    font-size: 12px;
  }

  .contact-details svg {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }

  .contact-details span {
    font-size: 10px;
  }
} */
</style>
